import { exitSearch, lazyEndSearchSession, SearchScenarioId } from 'owa-search';
import { lazyHideReadingPane } from 'owa-calendar-reading-pane-actions';
import { lazyInitSearchResults } from 'owa-calendar-searchresults-store';
import { setSearchState } from 'owa-calendar-search-view-store';
import { createLazyOrchestrator } from 'owa-bundling';

export const exitSearchOrchestrator = createLazyOrchestrator(
    exitSearch,
    'CLONE_EXIT_CALENDAR_SEARCH',
    async actionMessage => {
        if (actionMessage.scenarioId != SearchScenarioId.Calendar) {
            return;
        }
        lazyHideReadingPane.importAndExecute();
        setSearchState(false);

        // clear search results store
        const initSearchResults = await lazyInitSearchResults.import();
        initSearchResults();

        // invoke endSearchSession common action
        const endSearchSession = await lazyEndSearchSession.import();
        endSearchSession(SearchScenarioId.Calendar);
    }
);
